
$(document).ready(function() {

  var winW = $(window).width();

  // lazy loads elements with default selector as '.lozad'
  const observer = lozad();
  observer.observe();

  $(window).load(function() {
    resizeHeader($('.barra').outerHeight(), $('header').outerHeight(), $('.infobar').outerHeight(), $('.nav-header').outerHeight(), true);
  });

  $(window).resize(function() {
    resizeHeader($('.barra').outerHeight(), $('header').outerHeight(), $('.infobar').outerHeight(), $('.nav-header').outerHeight(), false);
  });

  $(window).load(function(){
    $('.nav-header form').addClass('show');
  });

  $('header .icons li .search').click(function() {
    $('header .big-search').toggleClass('show');
    $('header .black-search').toggleClass('show');
  });

  $('header .big-search .cerrar-big-search').click(function() {
    $('header .big-search').toggleClass('show');
    $('header .black-search').toggleClass('show');
  });

  $('header .icons li .cart').click(function() {
    $('#minicart').addClass('show');
  });

  $('#minicart .cerrar').click(function() {
    $('#minicart').removeClass('show');
  });

  $('header .show-menu').click(function() {
    $('nav').addClass('show');
  });

  $('header nav .cerrar').click(function() {
    $('nav').removeClass('show');
  });

  $('.product .deon > h3').each(function() {
    $(this).addClass('accor');
    $(this).nextUntil('h3').wrapAll('<div class="hide-info"></div>')
  });

  $('.product .deon h3').click(function() {
    $(this).toggleClass('active');
    $(this).next('.hide-info').toggleClass('show');
  });

  $('.container-des-deon .deon > h3').each(function() {
    $(this).addClass('accor');
    $(this).nextUntil('h3').wrapAll('<div class="hide-info"></div>')
  });

  $('.container-des-deon .deon h3').click(function() {
    $(this).toggleClass('active');
    $(this).next('.hide-info').toggleClass('show');
  });

  $('.product .deon h3:nth-child(1)').click();

  $('footer .item > h4').each(function() {
    $(this).addClass('accor');
    $(this).nextUntil('h4').wrapAll('<div class="hide-info"></div>')
  });

  $('footer .item h4').click(function() {
    $(this).toggleClass('active');
    $(this).next('.hide-info').toggleClass('show');
  });

  $('.pro-int .ver').click(function() {
    $('.pro-int .gallery').addClass('show');
  });

  $('.pro-int .gallery .cerrar').click(function() {
    $('.pro-int .gallery').removeClass('show');
  });

  $('.product .des-int .inner > h3').each(function() {
    $(this).addClass('h3-int');
    $(this).nextUntil('h3').wrapAll('<div class="contacto"></div>')
  });

  $('.pro-int .contactar').click(function() {
    $('.pro-int .form').addClass('show');
  });

  $('.pro-int .form .cerrar').click(function() {
    $('.pro-int .form').removeClass('show');
  });

  // Collection
  if (winW < 830) {
    $('.facets__heading').click(function(){
      $(this).toggleClass('clicked');
      $('.template-collection .facets__disclosure').slideToggle(200);
    });
  }

  $('.filter-group').click(function(){
    $(this).toggleClass('active');
  });

  // Pop Up
  $('#popup .cerrar').click(function() {
    $('#popup').removeClass('show');
  });

  if ( winW < 830 ) {
    $('nav ul.menu > li.site-nav--has-dropdown').prepend('<span class="down"><i>+</i></span>');
    $('nav ul.menu > li.site-nav--has-dropdown span.down').click(function(){
      $(this).toggleClass('active');
      $(this).parent().siblings().children('.sub-menu').removeClass('show');
      $(this).parent().children('.sub-menu').toggleClass('show');
    });
    $('nav ul.menu > li > ul.sub-menu > li.site-nav--has-dropdown').prepend('<span class="down"><i>+</i></span>');
    $('nav ul.menu > li > ul.sub-menu > li.site-nav--has-dropdown span.down').click(function(){
      $(this).toggleClass('active');
      $(this).parent().siblings().children('.sub-sub-menu').removeClass('show');
      $(this).parent().children('.sub-sub-menu').toggleClass('show');
    });
  }

  // Agregar on sale

  $('.featured-collection li.item').each(function(){
    var saleSize = $(this).find('.una[data-sale="sale"]').length;
    if (saleSize > 0) {
      $(this).addClass('on-sale');
    }
  });

  $('.product').each(function(){
    var saleSize2 = $(this).find('.una[data-sale="sale"]').length;
    if (saleSize2 > 0) {
      $(this).addClass('on-sale');
    } else {
      //$(this).find('.descuento').hide(1);
    }
  });

  /**
   * Escucha permanente para agregar productos, funciona para snippet
   * product-item.liquid
   *
   * @param object this  Contiene el objeto del elemento cliqueado.
   */
  $('body').on('click', '.item .addcart', function(e) {
    let proVar = $(this).data('product-id');
    let proQt = $(this).siblings('.sec-cantidad').children().children('input').val();
    let socioPrice = $(this).data('socioprice');
    let normalPrice = $(this).data('normalprice');
    let ofertaPrice = $(this).data('ofertaprice');

    let element = e.target.parentElement.parentElement.parentElement.parentElement

    if($(element).is("ul")){
      element = e.target.parentElement.parentElement.parentElement
    }

    if (proQt == undefined) {
      var newQt = 1;
    } else {
      var newQt = parseInt(proQt);
    }
    jQuery.ajax({
      type: "POST",
      url: '/cart/add.js',
      data: {
        quantity: newQt,
        id: proVar,
        properties: {
          socioPrice: socioPrice,
          ofertaPrice: ofertaPrice,
          normalPrice: normalPrice
        }
      },
      success: function(data) {
        console.log({socioPrice});
        console.log({ofertaPrice});
        console.log({normalPrice});
      },
      error: function(data) {
        if (data.status == 422) {
          $('.item-' + proVar + ' .alertas').text('Sin stock disponible');
        }
      },
      async: false
    });
    update_mini_cart(true);
  });

  /**
   * Escucha permanente para input quantity-up, funciona para snippet
   * product-item.liquid
   *
   * @param object this  Contiene el objeto del elemento cliqueado.
   */
  $('body').on('click', '.sec-cantidad .quantity-up', function() {
    let input_quantity = this.parentNode.parentElement.firstElementChild;
    let newVal = parseFloat(input_quantity.value);
    if (input_quantity.hasAttribute("max")) {
      if (newVal <= input_quantity.attributes.max.value) {
        newVal++;
      }
    } else {
      newVal++;
    }
    input_quantity.value = newVal;
  });

  /**
   * Escucha permanente para input quantity-down, funciona para snippet
   * product-item.liquid
   *
   * @param object this  Contiene el objeto del elemento cliqueado.
   */
  $('body').on('click', '.sec-cantidad .quantity-down', function() {
    let input_quantity = this.parentNode.parentElement.firstElementChild;
    let newVal = parseFloat(input_quantity.value);
    if (input_quantity.hasAttribute("min")) {
      if (newVal >= input_quantity.attributes.min.value) {
        newVal--;
      }
    } else {
      newVal--;
    }
    input_quantity.value = newVal;
  });

  // multiselector();
});

/**
 * Swiper launcher product-section
 *
 * @param object this  Contiene el objeto del elemento cliqueado.
 */
var thumbsSwiper = new Swiper(".mySwiper", {
  spaceBetween: 10,
  // centeredSlides: true,
  centeredSlidesBounds: true,
  slidesPerView: 4,
  watchOverflow: true,
  watchSlidesVisibility: true,
  watchSlidesProgress: true,
  loop: true,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  }
});

var swiper = new Swiper(".mySwiper2", {
  spaceBetween: 10,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  loop: true,
  thumbs: {
    swiper: thumbsSwiper,
    autoScrollOffset: 1
  },
});

function openCity(evt, cityName) {
  var i, tabcontent, tablinks;
  tabcontent =  document.getElementsByClassName("tabcont-");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }
  tablinks = document.getElementsByClassName("tab-");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }
  document.getElementById(cityName).style.display = "block";
  evt.currentTarget.className += " active";
}

/**
 * Escucha permanente para borrar producto del mini carro
 *
 * @param object this  Contiene el objeto del elemento cliqueado.
 */
$('body').on('click', '#minicart .middle .left i.delete-prod', function() {
  var var_this = this;
  Shopify.removeItem($(this).data('id'), function() {
    $(var_this).css("margin", "0").parent().parent().slideUp(200);
    update_mini_cart(false, false);
  });
});


function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

/**
 * Actualiza el mini carro
 *
 * @param boolean show  Muestra el menu
 * @param boolean all   Actualiza el sector medio del mini carro
 */
function update_mini_cart(show = false, all = true) {
  if (all) {
    $('#minicart .middle ul').empty();
  }
  $("#minicart .cifra").empty();
  jQuery.get("/cart.js", function(data) {
    // Bold:PRE
if(typeof window.BOLD !== 'undefined'
&& typeof window.BOLD.common !== 'undefined'
&& typeof window.BOLD.common.cartDoctor !== 'undefined') {
// NOTE: "cart" should be the variable containing the cart json data
data = window.BOLD.common.cartDoctor.fix(data);
}
// Bold:PRE
    for (var i = 0; i < data.items.length; i++) {
      var titulo     = data.items[i]["product_title"];
      var tituloname     = data.items[i]["options_with_values"][0]['name'];
      var titulovalue     = data.items[i]["options_with_values"][0]['value'];
      var varianteID = data.items[i]["variant_id"];
      var precio     = data.items[i]["price"] ? parseFloat(data.items[i]["price"]).toString().substring(0, parseFloat(data.items[i]["price"]).toString().length - 2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1.") : '0';
      var cantidad   = data.items[i]["quantity"];
      var imagen     = data.items[i]["image"];
      var alt        = data.items[i]["featured_image"]["alt"];
      if (tituloname == 'Title') {
        var tituloname = '';
      }
      if (titulovalue == 'Default Title') {
        var titulovalue = '';
      }
      var proMini    = "<li><div class='left'><i class='delete-prod' data-id='" + varianteID + "'></i><h4>" + titulo + "</h4><h4 class='sub'>" + tituloname + " " + titulovalue + "</h4><h5>$" + precio + "</h5><h6>Cantidad: <span>" + cantidad + "</span></h6></div><div class='right'><img class='lozad' src='" + imagen + "' alt='" + alt + "' loading='lazy' /></div></li>";
      if (all) {
        $("#minicart .middle ul").append(proMini);
      }
    }
    var total     = data.total_price ? data.total_price.toString().substring(0, data.total_price.toString().length - 2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1.") : '0';
    var itemcount = data.item_count;
    $("#minicart .cifra").html('$' + total);
    $("header .icons li a.cart .count").html(itemcount);
    if (show) {
      $('#minicart').addClass('show');
    }

    if (window.BOLD && BOLD.common && BOLD.common.eventEmitter &&
                  typeof BOLD.common.eventEmitter.emit === 'function'){
                BOLD.common.eventEmitter.emit('BOLD_COMMON_cart_loaded');
 }


  }, 'json');
}

/**
 * Devuelve el stock de la variante seleccionada
 *
 * @param object stock  Inventario de la ariante
 */

 function get_stock(stock = 0) {
   if (stock == 0) {
     $('.remain p').html('Producto agotado');
     $('#sobre-agregar').fadeIn(100);
   } else if (stock == undefined ) {
     $('#sobre-agregar').fadeIn(100);
   } else if (stock == 1) {
     $('.remain p').html('Queda sólo ' + stock + '');
     $('#sobre-agregar').fadeOut(100);
   } else if (stock > 1 && stock < 6) {
     $('.remain p').html('Quedan sólo ' + stock + '');
     $('#sobre-agregar').fadeOut(100);
   } else {
    $('.remain p').html(stock + ' disponibles');
     $('#sobre-agregar').fadeOut(100);
   }
 }

/**
 * Si en algún momento hay errores de carga de jQuery.
 * Uso: defer(function () { //= acá va la funcion =// });
 *
 * @param object method  Funcion completa a ejecutar
 */
function defer(method) {
  if (window.jQuery) {
    method();
  } else {
    setTimeout(function() { defer(method) }, 50);
  }
}

/**
 * Crea y escucha permanente para input quantity, funciona para section
 * product-recommendations.liquid
 *
 * @param boolean ajax  Se utiliza para product recommendations.
 */
// function quantity_elements(ajax = false) {
//   if (ajax) {
//     $('<div class="quantity-nav"><div class="quantity-button quantity-up">+</div><div class="quantity-button quantity-down">-</div></div>').insertAfter('.product-recommendations .sec-cantidad input');
//     $('.product-recommendations .sec-cantidad').each(function() {
//       var spinner = $(this), input = spinner.find('input[type="number"]'), btnUp = spinner.find('.quantity-up'), btnDown = spinner.find('.quantity-down'), min = input.attr('min'), max = input.attr('max');
//       btnUp.click(function() {
//         var oldValue = parseFloat(input.val());
//         if (oldValue >= max) {
//           var newVal = oldValue;
//         } else {
//           var newVal = oldValue + 1;
//         }
//         spinner.find("input").val(newVal);
//         spinner.find("input").trigger("change");
//       });
//       btnDown.click(function() {
//         var oldValue = parseFloat(input.val());
//         if (oldValue <= min) {
//           var newVal = oldValue;
//         } else {
//           var newVal = oldValue - 1;
//         }
//         spinner.find("input").val(newVal);
//         $(spinner).parent().find(".addcart").data("qt", newVal);
//         spinner.find("input").trigger("change");
//       });
//     });
//   } else {
//     //$('<div class="quantity-nav"><div class="quantity-button quantity-up">+</div><div class="quantity-button quantity-down">-</div></div>').insertAfter('.sec-cantidad input');
//     $('.sec-cantidad').each(function() {
//       var spinner = $(this), input = spinner.find('input[type="number"]'), btnUp = spinner.find('.quantity-up'), btnDown = spinner.find('.quantity-down'), min = input.attr('min'), max = input.attr('max');
//       btnUp.click(function() {
//         var oldValue = parseFloat(input.val());
//         if (oldValue >= max) {
//           var newVal = oldValue;
//         } else {
//           var newVal = oldValue + 1;
//         }
//         spinner.find("input").val(newVal);
//         spinner.find("input").trigger("change");
//       });
//       btnDown.click(function() {
//         var oldValue = parseFloat(input.val());
//         if (oldValue <= min) {
//           var newVal = oldValue;
//         } else {
//           var newVal = oldValue - 1;
//         }
//         spinner.find("input").val(newVal);
//         $(spinner).parent().find(".addcart").data("qt", newVal);
//         spinner.find("input").trigger("change");
//       });
//     });
//   }
// }

// function multiselector() {
//   $("body").on('click', '.item .tallas li', function () {
//     var liValue    = $(this).data('name');
//     var liId       = $(this).closest('.item').data('id');
//     var newVal     = $('.item-' + liId + ' #pro-variants').find('option').filter('[data-name="' + liId + '"]').attr('value');
//     var varPrice   = $('.item-' + liId + ' #pro-variants').find('option').filter('[data-name="' + liValue + '"]').data('price');
//     var varCompare = $('.item-' + liId + ' #pro-variants').find('option').filter('[data-name="' + liValue + '"]').data('compare');
//     var varDes     = $('.item-' + liId + ' #pro-variants').find('option').filter('[data-name="' + liValue + '"]').data('descuento');
//     var varId      = $('.item-' + liId + ' #pro-variants').find('option').filter('[data-name="' + liValue + '"]').val();
//     if (varCompare == '') {
//       if(liValue == 1) {
//         $('.item-' + liId + ' .unidad-view').html(liValue + ' unidad');
//       } else {
//         $('.item-' + liId + ' .unidad-view').html(liValue + ' unidades');
//       }
//       $('.item-' + liId + ' .price').removeClass('sale').text(varPrice);
//       $('.item-' + liId + ' .descuento').addClass('hide').text('');
//     } else {
//       if(liValue == 1) {
//         $('.item-' + liId + ' .unidad-view').html(liValue + ' unidad');
//       } else {
//         $('.item-' + liId + ' .unidad-view').html(liValue + ' unidades');
//       }
//       $('.item-' + liId + ' .price').addClass('sale').html(varPrice + '<span>' + varCompare + '</span>');
//       $('.item-' + liId + ' .descuento').removeClass('hide').html('-' + varDes + '% OFF');
//     }
//     $('.item-' + liId + ' .addcart').attr('data-product-id', varId);
//     $('.item-' + liId + ' #pro-variants').val(newVal).trigger('change');
//     $(this).addClass('active');
//     $(this).siblings().removeClass('active');
//   });

//   $('.item ul.tallas li[data-name="1"], li[data-product-type="Licores"] ul.tallas li[data-name="1"]').click();
//   $('.item #pro-variants option:contains("1"), li[data-product-type="Licores"] #pro-variants option:contains("1")').prop('selected',true);
//   $('li[data-product-type="Vinos"] ul.tallas li[data-name="1"], li[data-product-type="Cervezas"] ul.tallas li[data-name="1"]').click();
//   $('li[data-product-type="Vinos"] #pro-variants option:contains("1"), li[data-product-type="Cervezas"] #pro-variants option:contains("1")').prop('selected',true);
// }



  // $("body").on('click', '.item .tallas li', function () {
  //   var liValue    = $(this).data('name');
  //   var liId       = $(this).closest('.item').data('id');
  //   var newVal     = $('.item-' + liId + ' #pro-variants').find('option').filter('[data-name="' + liId + '"]').attr('value');
  //   var varPrice   = $('.item-' + liId + ' #pro-variants').find('option').filter('[data-name="' + liValue + '"]').data('price');
  //   var varCompare = $('.item-' + liId + ' #pro-variants').find('option').filter('[data-name="' + liValue + '"]').data('compare');
  //   var varDes     = $('.item-' + liId + ' #pro-variants').find('option').filter('[data-name="' + liValue + '"]').data('descuento');
  //   var varId      = $('.item-' + liId + ' #pro-variants').find('option').filter('[data-name="' + liValue + '"]').val();
  //   if (varCompare == '') {
  //     if(liValue == 1) {
  //       $('.item-' + liId + ' .unidad-view').html(liValue + ' unidad');
  //     } else {
  //       $('.item-' + liId + ' .unidad-view').html(liValue + ' unidades');
  //     }
  //     $('.item-' + liId + ' .price').removeClass('sale').text(varPrice);
  //     $('.item-' + liId + ' .descuento').addClass('hide').text('');
  //   } else {
  //     if(liValue == 1) {
  //       $('.item-' + liId + ' .unidad-view').html(liValue + ' unidad');
  //     } else {
  //       $('.item-' + liId + ' .unidad-view').html(liValue + ' unidades');
  //     }
  //     $('.item-' + liId + ' .price').addClass('sale').html(varPrice + '<span>' + varCompare + '</span>');

  //     varDes <= 0 ? null : $('.item-' + liId + ' .descuento').removeClass('hide').html('-' + varDes + '% OFF')

  //   }
  //   $('.item-' + liId + ' .addcart').attr('data-product-id', varId);
  //   $('.item-' + liId + ' #pro-variants').val(newVal).trigger('change');
  //   $(this).addClass('active');
  //   $(this).siblings().removeClass('active');
  // });

  $('.item #pro-variants option:contains("1"), li[data-product-type="Licores"] #pro-variants option:contains("1")').addClass('active');
  // $('.item ul.tallas li[data-name="1"], li[data-product-type="Licores"] ul.tallas li[data-name="1"]').click();
  $('.item #pro-variants option:contains("1"), li[data-product-type="Licores"] #pro-variants option:contains("1")').prop('selected',true);
  // $('li[data-product-type="Vinos"] ul.tallas li[data-name="1"], li[data-product-type="Cervezas"] ul.tallas li[data-name="1"]').click();
  $('li[data-product-type="Vinos"] #pro-variants option:contains("1"), li[data-product-type="Cervezas"] #pro-variants option:contains("1")').prop('selected',true);



document.addEventListener("DOMContentLoaded", function() {
  var lazyloadImages;

  if ("IntersectionObserver" in window) {
    lazyloadImages = document.querySelectorAll(".lazy");
    var imageObserver = new IntersectionObserver(function(entries, observer) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          var image = entry.target;
          image.classList.remove("lazy");
          imageObserver.unobserve(image);
        }
      });
    });

    lazyloadImages.forEach(function(image) {
      imageObserver.observe(image);
    });
  } else {
    var lazyloadThrottleTimeout;
    lazyloadImages = document.querySelectorAll(".lazy");

    function lazyload () {
      if(lazyloadThrottleTimeout) {
        clearTimeout(lazyloadThrottleTimeout);
      }

      lazyloadThrottleTimeout = setTimeout(function() {
        var scrollTop = window.pageYOffset;
        lazyloadImages.forEach(function(img) {
          if(img.offsetTop < (window.innerHeight + scrollTop)) {
            img.src = img.dataset.src;
            img.classList.remove('lazy');
          }
        });
        if(lazyloadImages.length == 0) {
          document.removeEventListener("scroll", lazyload);
          window.removeEventListener("resize", lazyload);
          window.removeEventListener("orientationChange", lazyload);
        }
      }, 20);
    }

    document.addEventListener("scroll", lazyload);
    window.addEventListener("resize", lazyload);
    window.addEventListener("orientationChange", lazyload);
  }
});

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');
    const summaryElements = this.querySelectorAll('summary');
    this.addAccessibilityAttributes(summaryElements);

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  addAccessibilityAttributes(summaryElements) {
    summaryElements.forEach(element => {
      element.setAttribute('role', 'button');
      element.setAttribute('aria-expanded', false);
      element.setAttribute('aria-controls', element.nextElementSibling.id);
    });
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));

      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
      });
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add('overflow-hidden-mobile');
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove('menu-opening');
      this.mainDetailsToggle.querySelectorAll('details').forEach(details =>  {
        details.removeAttribute('open');
        details.classList.remove('menu-opening');
      });
      this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
      document.body.classList.remove('overflow-hidden-mobile');
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
    }
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening');
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

function resizeHeader(barraH = 0, headerH = 0, infoH = 0, navH  = 0 , scroll = true) {
  if ( $(window).width() > 830 ) {
    $('body').css('padding-top', barraH + headerH + navH );
    $('header').css('top', barraH + navH );
    $('.nav-header').css('top', barraH);
    if (scroll === true) {
      $(window).scroll(function() {
        if ($(window).scrollTop() > barraH + navH) {
          $('header').addClass('fix');
          $('header').css('top', 0);
        } else {
          $('header').removeClass('fix');
          $('header').css('top', barraH + navH);
        }
      });
    }
  } else {
    $('body').css('padding-top', barraH + headerH + navH);
    $('header').css('top', barraH + navH );
    $('.nav-header').css('top', barraH);
    if (scroll === true) {
      $(window).scroll(function() {
        if ($(window).scrollTop() > barraH + navH) {
          $('header').addClass('fix');
          $('header').css('top', 0);
        } else {
          $('header').removeClass('fix');
          $('header').css('top', barraH + navH);
        }
      });
    }
  }
}
